enum ESoftwareRegistryAlertStatus {
  DEFAULT = 'default',
  SUCCESS = 'success',
  ERROR = 'error',
  SERVER_ERROR = 'serverError',
}

export default ESoftwareRegistryAlertStatus;
